import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const wasThrownByOriginalChildren = Symbol('wasThrownByOriginalChildren');
export default class ChildrenErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      _isOriginalChildren
    } = this.props;
    Raven.captureException(error, errorInfo);
    if (_isOriginalChildren) {
      error[wasThrownByOriginalChildren] = true;
      throw error;
    }
    if (error[wasThrownByOriginalChildren]) {
      // If this error came from `originalChildren`, then it should bubble up
      // for the parent app to handle. Continuing to render `originalChildren`
      // could create an infinite loop.
      throw error;
    }
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(ChildrenErrorBoundary, {
        _isOriginalChildren: true,
        originalChildren: null,
        children: this.props.originalChildren
      });
    }
    return this.props.children;
  }
}
ChildrenErrorBoundary.propTypes = {
  children: PropTypes.node,
  originalChildren: PropTypes.node,
  _isOriginalChildren: PropTypes.bool
};
ChildrenErrorBoundary.defaultProps = {
  children: null,
  originalChildren: null,
  _isOriginalChildren: false
};